import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { EMPTY_FORM_ASSIGNMENT_PAGE_MODEL, PatientFormAssignmentPageModel } from '../../global-data-models/form-assignment.model';
import { FormAssignmentService, FormAssignmentPageOptions, PatientFormAssignmentPageOptions } from '../../global-services/form-assignment.service';
import { GlobalMessageService } from '../../global-services/global-message.service';
import { GlobalLoadingService } from '../../global-services/global-loading.service';

export interface FormAssignmentsUiState {
  formAssignmentPage: PatientFormAssignmentPageModel;
}

export type FormAssignmentsViewMode = "patient" | "org";

const EMPTY_FORMS_VIEW_UI_STATE: FormAssignmentsUiState = { formAssignmentPage: EMPTY_FORM_ASSIGNMENT_PAGE_MODEL };

@Injectable({ providedIn: 'root' })
export class FormAssignmentsFacade {
  private uiState: FormAssignmentsUiState = EMPTY_FORMS_VIEW_UI_STATE;
  private readonly _uiState$ = new BehaviorSubject<FormAssignmentsUiState>(this.uiState);
  public readonly uiState$ = this._uiState$.asObservable();
  private readonly destroy$ = new Subject<void>();

  public constructor(
    private readonly formAssignmentService: FormAssignmentService,
    private readonly messageService: GlobalMessageService,
    private readonly loadingService: GlobalLoadingService,
  ) { }

  public async loadFormAssignments(mode: FormAssignmentsViewMode, pageOptions: FormAssignmentPageOptions | PatientFormAssignmentPageModel): Promise<void> {
    this.loadingService.show();
    try {
      let _formAssignmentPage: PatientFormAssignmentPageModel;

      switch (mode) {
        case "org":
          _formAssignmentPage = await this.formAssignmentService.getFormAssignmentsPage(pageOptions as FormAssignmentPageOptions);
          break;
        case "patient":
          _formAssignmentPage = await this.formAssignmentService.getPatientFormAssignmentsPage(pageOptions as PatientFormAssignmentPageOptions);
          break;
      }

      this._uiState$.next({ formAssignmentPage: _formAssignmentPage ?? EMPTY_FORMS_VIEW_UI_STATE });
    } catch (error: Error | any) {
      this._uiState$.next(EMPTY_FORMS_VIEW_UI_STATE);
      this.messageService.showError('Get Form Assignments Error', error.message);
    } finally {
      this.loadingService.hide();
    }
  }

  public destroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
